import { ISpotList } from "Domain/Model/SpotList/SpotList";

export const CREATE_SPOT_LIST_REQUEST = 'CREATE_SPOT_LIST_REQUEST';

export const createSpotListRequest = ( spotListData: ISpotList ) => ({
    type: CREATE_SPOT_LIST_REQUEST,
    payload: { spotListData },
});
